import * as hooks from './hooks'
import * as types from './types'

console.log('Tags feature initialized!')

export { hooks, types }
